// Dropdown.tsx

import React, {
  useRef,
  useState,
} from 'react';

import { constCommon } from 'constants/constCommon';
import {
  animated,
  useSpring,
} from 'react-spring';
import styled from 'styled-components';
import { Icon } from 'view/components/common/Icon';

interface DropdownProps {
  onClick:any;
  title:string;
  depth?: any;
  icon:any;
  isActive:boolean; 
  subTitle?:any; 
}
interface StyledComponentProps {
  isActive?: boolean;
  isOpen?:boolean;
  on?:boolean
}
const MenuItem: React.FC<DropdownProps> = ({ depth, title, onClick = ()=>{}, icon,
isActive, subTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const dropdownAnimation = useSpring({
    height: isOpen ? dropdownRef.current?.scrollHeight  || 'auto' : 0,
    opacity: isOpen ? 1 : 0,
    from: { height: 0, opacity: 0 },
    config: { tension: 500, friction: 50, }, // tension과 friction 값 조절
  });

  const handleItemClick = () => {
    depth && toggleDropdown();
    onClick();
  };

  return (
      <Container>
          <Title onClick={handleItemClick} isActive={isActive} isOpen={isOpen}>
              <Icon icon={icon} />
              <h4>{title}</h4>
              {depth && (
                  <div className="dropdownIcon">
                      <Icon width={11.3} height={6} icon={constCommon.ICON.ARROW.DOWN} />
                  </div>
              )}
          </Title>
          <DropdownContainer style={{ ...dropdownAnimation }} ref={dropdownRef}>
              <div style={{ height: 10 }}></div>
              {depth &&
                  depth.map((item: any, index: number) => (
                      <DropdownItem key={index} on={isActive && item.itemTitle === subTitle} onClick={() => item.itemClick()}>
                          <Circle />
                          {item.itemTitle}
                      </DropdownItem>
               ))}
          </DropdownContainer>
      </Container>
  );
};

const Container = styled.div`
  margin-bottom: 8px;
`;
const DropdownContainer = styled(animated.div)`
  overflow: hidden;
  padding: 0 15px;
`;
const DropdownItem = styled.div.withConfig({
    shouldForwardProp: (prop) => !['on', 'isActive', 'isOpen'].includes(prop),
})<StyledComponentProps>`
    transition: opacity, background 0.2s;
  cursor: pointer;
  padding: 8px 15px;
  background:${props => props.on ? "#F8F7F0" : "transparents"};
  border-radius: 5px;
  align-items: center;
  display: flex;
  margin: 8px 0;
  font-size: 16px;
  line-height: 16px;
  opacity: ${props => props.on ? 1 : 0.6};
  &:hover{
      background: #E5E5E5;
  }
`;
const Title = styled.div.withConfig({
    shouldForwardProp: (prop) => !['on', 'isActive', 'isOpen'].includes(prop),
})<StyledComponentProps>`
  padding: 15px;
  cursor: pointer;
  display: flex;
    color: #333;
  justify-content: space-between;
  width: 100%;
  align-items: center;
    
  background:${props => props.isActive ? "#DDC160" : "transparents"};  
  border-radius: 5px;
  h4{
      font-family: Europa-Regular!important;
    font-weight: 100;
    width: 100%;
    padding: 0 15px 0 20px;
    font-size: 16px;
  }
  .dropdownIcon{
    transform: rotate(${props => props.isOpen ? 180 : 0}deg);
  }
`;
const Circle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #ddc160;
  margin-right: 10px;
  margin-bottom: 2px;
`;
export { MenuItem };
